<svg width="122" height="2" viewBox="0 0 122 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM121 2H122V0H121V2ZM1 2H121V0H1V2Z" fill="#333333" fill-opacity="0.25"/>
</svg>
